import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading';

export default {
	name: 'Auto-Handover-Outbound-Pendency',
	components: {
		VueElementLoading,
		Paginate
	},
	data: function() {
		return {
			batchNo: '',
			batchNoErrorMSG: '',
			isLoadingSearch: false,
			isLoadingMPS: false,
			BatchData: [],
			modalShow: false,
			modalShowecom: false,
			checkedType: 'cargo',
			isEcom: false,
			mpsdata: [],
			bagdata: [],
			batchid: '',
			createdBy: '',
			CurrentHubName: '',
			pageIndex: 0,
			pageSize: 20,
			totalCount: 0,
			pageCount: 0
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.currenthubid = userdetail[0].HubId[0];
		this.loadList(0);
	},
	methods: {
		checkField() {
			this.batchNo = '';
			this.pageIndex = 0;
			this.loadList(0);
		},
		buildListUrl(searchParam) {
			let url = apiUrl.api_url_hubops + 'SearchOutboundPendencyBatch?isEcom=' + this.isEcom
				+ '&currentHubId=' + this.currenthubid
				+ '&pageIndex=' + this.pageIndex
				+ '&pageSize=' + this.pageSize;
			if (searchParam) {
				url += '&searchParam=' + encodeURIComponent(searchParam);
			}
			return url;
		},
		loadList(pageIndex) {
			this.pageIndex = pageIndex;
			if (this.checkedType === 'cargo') {
				this.isEcom = false;
			} else {
				this.isEcom = true;
			}
			this.isLoadingSearch = true;
			axios({
				method: 'GET',
				url: this.buildListUrl(''),
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
					'requestfrom': 'WEB',
					'token': this.token
				}
			}).then(result => {
				this.isLoadingSearch = false;
				let response = result.data;
				if (response.ResultCode == 100) {
					this.BatchData = response.ResponseData;
					this.CurrentHubName = response.CurrentHubName;
					this.totalCount = response.TotalCount || 0;
					this.pageCount = Math.max(1, Math.ceil(this.totalCount / this.pageSize));
				} else {
					this.BatchData = [];
					this.totalCount = 0;
					this.pageCount = 0;
					this.$alertify.error(response.ReturnMessage);
				}
			}, error => {
				console.error(error);
				this.isLoadingSearch = false;
			});
		},
		searchBatchNo() {
			if (!this.batchNo) {
				this.batchNoErrorMSG = 'Enter batchNo';
				return false;
			}
			this.batchNoErrorMSG = '';
			if (this.checkedType === 'cargo') {
				this.isEcom = false;
			} else {
				this.isEcom = true;
			}
			this.pageIndex = 0;
			this.isLoadingSearch = true;
			axios({
				method: 'GET',
				url: this.buildListUrl(this.batchNo),
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
					'requestfrom': 'WEB',
					'token': this.token
				}
			}).then(result => {
				this.isLoadingSearch = false;
				let response = result.data;
				if (response.ResultCode == 100) {
					this.BatchData = response.ResponseData;
					this.totalCount = response.TotalCount || 0;
					this.pageCount = Math.max(1, Math.ceil(this.totalCount / this.pageSize));
				} else {
					this.BatchData = [];
					this.$alertify.error(response.ReturnMessage);
				}
			}, error => {
				console.error(error);
				this.isLoadingSearch = false;
			});
		},
		getPaginationData(pageNum) {
			this.loadList(pageNum - 1);
		},
		rowSno(index) {
			return (this.pageIndex * this.pageSize) + index + 1;
		},
		bmodalopen(data) {
			if (!data.MPScount || data.MPScount <= 0) {
				return;
			}
			this.batchid = data.batchid;
			this.createdBy = data.createdby;
			this.getMPSDetails();
		},
		bmodalclose() {
			this.modalShow = false;
		},
		bmodalopenecom(data) {
			if (!data.Bagcount || data.Bagcount <= 0) {
				return;
			}
			this.batchid = data.batchid;
			this.createdBy = data.createdby;
			this.getBAGDetails();
		},
		bmodalcloseecom() {
			this.modalShowecom = false;
		},
		getMPSDetails() {
			this.mpsdata = [];
			this.modalShow = false;
			this.isLoadingMPS = true;
			axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'getMPSNo?BatchNo=' + this.batchid + '&createdBy=' + this.createdBy,
				headers: { 'authorization': 'authkey xB84JJ89Hd25' }
			}).then(result => {
				this.isLoadingMPS = false;
				const response = result.data;
				if (response.ResultCode == 100 && response.ResponseData && response.ResponseData.length) {
					this.mpsdata = response.ResponseData;
					this.modalShow = true;
				} else {
					this.$alertify.error(response.ReturnMessage || 'No pending MPS details found');
				}
			}, () => {
				this.isLoadingMPS = false;
				this.$alertify.error('Unable to load MPS details');
			});
		},
		getBAGDetails() {
			this.bagdata = [];
			this.modalShowecom = false;
			this.isLoadingMPS = true;
			axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'getBagListForB2C?batchid=' + this.batchid + '&limit=500&offset=0',
				headers: { 'authorization': 'authkey xB84JJ89Hd25' }
			}).then(result => {
				this.isLoadingMPS = false;
				const response = result.data;
				if (response.ResultCode == 100 && response.ResponseData && response.ResponseData.length) {
					this.bagdata = response.ResponseData;
					this.modalShowecom = true;
				} else {
					this.$alertify.error(response.ReturnMessage || 'No bag details found');
				}
			}, () => {
				this.isLoadingMPS = false;
				this.$alertify.error('Unable to load bag details');
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/AutoHandover_v1/OutboundPendency/OutboundPendency.js